import React, { useCallback, useEffect, useState } from 'react';
import DauBar from './DauBar';
import DauTable from './DauTable';
import moment from 'moment';
import { getTrendsDauInfo } from '@/pages/opinion/services/trends';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl } from 'umi';
import { downloadAction } from '@/pages/opinion/components/DownloadCommon/download-page';
import './index.scss';
import { barIcon, tableIcon } from '@/pages/opinion/constants/chart';
const DauComponentMap = {
  table: DauTable,
  bar: DauBar,
};

function dealWithDauData(
  data: Array<{
    date: string;
    hot_index_number: number;
    id: number;
    rank: number;
  }>,
  start_time: string,
  end_time: string,
) {
  let result: any = {};
  if (Array.isArray(data)) {
    data.forEach(({ date, hot_index_number, id, rank }) => {
      if (rank > 10) {
        return;
      }
      if (!result[rank]) {
        result[rank] = { id, yesterday: 0, today: 0, date: end_time, rank };
      }
      if (date === start_time) {
        result[rank]['yesterday'] = hot_index_number;
      } else {
        result[rank]['today'] = hot_index_number;
      }
    });
  }
  return Object.values(result);
}

export default function DauCard({
  params,
  wholeGameInfo,
}: {
  params: any;
  wholeGameInfo: any;
}) {
  const [tableData, setTableData] = useState<Array<any>>([]);

  const [loading, setLoading] = useState(false);

  const download = () => {
    const downloadLimit = 150000; //下载限制条数

    const gameName = wholeGameInfo?.entity_name || '';

    const fileName = `Opinions_${gameName}_Trends_Top10_Searches_${moment(
      params.start_time,
    ).format('YYYYMMDD')}_${moment(params.end_time).format('YYYYMMDD')}`;
    downloadAction({
      limit: downloadLimit,
      fileName,
      downLoadParams: params,
      downloadFunc: 'getTrendsDAUDownload',
    });
  };

  useEffect(() => {
    if (!params.region) {
      return;
    }
    const localParams = JSON.parse(JSON.stringify(params));
    localParams.start_time = moment(params.end_time)
      .subtract(1, 'days')
      .format('YYYY-MM-DD');
    setLoading(true);
    getTrendsDauInfo(params)
      .then((data: any) => {
        setTableData(
          dealWithDauData(data, localParams.start_time, localParams.end_time),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  const [type, setType] = useState<'bar' | 'table'>('bar');
  const ChartElement = useCallback(
    (type: 'bar' | 'table') => {
      const Component = DauComponentMap[type];
      return <Component originalData={tableData}></Component>;
    },
    [tableData],
  );
  const { formatMessage } = useIntl();
  return (
    <CardCommon
      className="dbo-dau-table-wrapper"
      title={formatMessage({ id: 'Top 10 Searches' })}
      operations={[barIcon, tableIcon]}
      loading={loading}
      hasDownload
      handleOperationsOnClick={(item: any) => setType(item.symbol)}
      handleDownloadOnClick={download}
      empty={tableData?.length === 0}
      loadingHeight={312}
      emptyHeight={312}
      bodyStyle={{ height: 380 }}
    >
      {ChartElement(type)}
    </CardCommon>
  );
}
